package app.spliddy.web.pages

import androidx.compose.runtime.Composable
import app.spliddy.web.HeadlineTextStyle
import app.spliddy.web.Res
import app.spliddy.web.SubheadlineTextStyle
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div

// Container that has a tagline and grid on desktop, and just the tagline on mobile
val HeroContainerStyle =
    CssStyle {
        base { Modifier.fillMaxWidth().gap(2.cssRem) }
        Breakpoint.MD { Modifier.margin { top(15.vh) } }
    }

val AppDemoImageStyle =
    CssStyle.base {
        Modifier
            .height(40.cssRem)
            .aspectRatio(9.0 / 19.5)
            .borderRadius(30.px)
            .background(Colors.Grey)
    }

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun HomePage() {
    Row(
        modifier = HeroContainerStyle.toModifier(),
        horizontalArrangement = Arrangement.SpaceAround,
    ) {
        Column(Modifier.fillMaxWidth().gap(2.cssRem)) {
            SpanText(
                text = Res.string.app_name,
                modifier = HeadlineTextStyle.toModifier(),
            )

            SpanText(
                text = Res.string.app_catch_phrase,
                modifier = SubheadlineTextStyle.toModifier(),
            )

            SpanText(Res.string.app_is_under_construction)

            Link(
                path = "/install",
                text = Res.string.app_download_app,
                modifier =
                    Modifier
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                        ).borderRadius(90.px)
                        .padding(topBottom = 0.5.cssRem, leftRight = 1.cssRem),
            )
        }

        Div(
            AppDemoImageStyle
                .toModifier()
                .displayIfAtLeast(Breakpoint.MD)
                .toAttrs(),
        )
    }
}
